import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        context: '=',
        canManageCourse: '=',
        courseVersion: '=',
        isStudyMaterialPublic: '='
    },
    template: `
        <div class="form nomargin type02">
            <form-row-wide error="vm.form.errors.name">
                <span class="row row-wide" ng-class="{ 'has-error': vm.form.errors.name }">
                    <label class="label w100p">
                        {{ 'course.Version name' | translate }}*
                        <tooltip html="vm.tooltipTexts.name" />
                    </label>
                    <div class="items w100p">
                        <input ng-disabled="!vm.canManageCourse" type="text" class="form-control" ng-model="vm.form.model.name">
                        <form-row-wide-error></form-row-error>
                    </div>
                </span>
            </form>
            <form class="row row-wide">
                <label class="label w100p">{{ 'courses.Order of trainings' | translate }}</label>
                <div class="items w100p">
                    <select ng-disabled="vm.isDisabled" class="form-control" name="nav1" ng-model="vm.form.model.trainingOrderType">
                        <option value="{{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.ANY }}">
                            {{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.LABELS.ANY }}
                        </option>
                        <option value="{{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.SEQUENCE }}">
                            {{ vm.COURSE_TRAINING_ORDER_TYPE_ENUM.LABELS.SEQUENCE }}
                        </option>
                    </select>
                    <p class="desc" ng-if="vm.form.model.trainingOrderType==vm.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.ANY">{{ 'version.Activities can be completed in any order' | translate }}</p>
                    <p class="desc" ng-if="vm.form.model.trainingOrderType==vm.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.SEQUENCE">{{ 'version.Activities can be completed in fixed order' | translate }}</p>
                </div>
            </form>
            <form class="row row-wide">
                <label class="label w100p">
                    {{ 'course.Course status format' | translate }}
                    <tooltip html="vm.tooltipTexts.courseStatusFormat" />
                </label>
                <div class="items w100p">
                    <select ng-disabled="vm.isDisabled" class="form-control" ng-model="vm.form.model.courseStatusFormat">
                        <option value="{{ vm.COURSE_STATUS_FORMAT_ENUM.KEYS.PASSED_FAILED }}">
                            {{ vm.COURSE_STATUS_FORMAT_ENUM.LABELS.PASSED_FAILED }}
                        </option>
                        <option value="{{ vm.COURSE_STATUS_FORMAT_ENUM.KEYS.COMPLETE_INCOMPLETE }}">
                            {{ vm.COURSE_STATUS_FORMAT_ENUM.LABELS.COMPLETE_INCOMPLETE }}
                        </option>
                    </select>
                </div>
            </form>
            <form class="row row-wide">
                <label class="label w100p">{{ 'courses.Study materials are accessible after course completion' | translate }}</label>
                <div class="items w100p">
                    <select ng-change="vm.handleIsStudyMaterialPublic()" class="form-control" ng-model="vm.isStudyMaterialPublic">
                        <option value="0">
                            {{ 'general.No' | translate }}
                        </option>
                        <option value="1">
                            {{ 'general.Yes' | translate }}
                        </option>
                    </select>
               </div>
            </form>
        </div>
    `
})

export default class {
    constructor ($stateParams, $translate, lodash, CourseResource, COURSE_TRAINING_TYPE_ENUM,
        COURSE_TRAINING_ORDER_TYPE_ENUM, COURSE_STATUS_FORMAT_ENUM, CourseVersionService) {
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.lodash = lodash;
        this.CourseResource = CourseResource;
        this.CourseVersionService = CourseVersionService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_ORDER_TYPE_ENUM = COURSE_TRAINING_ORDER_TYPE_ENUM;
        this.COURSE_STATUS_FORMAT_ENUM = COURSE_STATUS_FORMAT_ENUM;

        if (!this.form.model.name) {
            this.form.model.name = 'Version 1';
        }
        if (!this.form.model.trainingOrderType) {
            this.form.model.trainingOrderType = this.COURSE_TRAINING_ORDER_TYPE_ENUM.KEYS.ANY;
        }
    }

    $onInit () {
        this.otherVersionHasWithoutPlanning = true;
        this.CourseResource.get({ id: this.$stateParams.id, expand: 'courseVersions' }).$promise
            .then((course) => {
                this.otherVersionHasWithoutPlanning = this.lodash.find(course.courseVersions, (v) => v.isWithoutPlanning === true);
                if (!this.form.model.courseStatusFormat) {
                    this.form.model.courseStatusFormat = course.isGuidance
                        ? this.COURSE_STATUS_FORMAT_ENUM.KEYS.COMPLETE_INCOMPLETE
                        : this.COURSE_STATUS_FORMAT_ENUM.KEYS.PASSED_FAILED;
                }
            });
        this.tooltipTexts = {
            name: this.$translate.instant('course.Version name tooltip'),
            courseStatusFormat: this.$translate.instant('course.Course status format tooltip')
        };

        this.hasPublishedOccurrence = this.CourseVersionService.getPublishedOccurrenceCount(this.courseVersion);
        this.isDisabled = !this.canManageCourse || this.hasPublishedOccurrence !== 0;
    }

    isWithoutPlanningDisabled () {
        return !this.canManageCourse
            || (this.courseVersion !== undefined && (this.courseVersion.isWithoutPlanning || this.courseVersion.courseOccurrences.length))
            || this.otherVersionHasWithoutPlanning;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/version/index.js